require('../../modules/es6.object.define-property');
var $Object = require('../../modules/_core').Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};



//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/fn/object/define-property.js
// module id = 49
// module chunks = 24564523585802 77757019989577 88899200817339 114276838955818 159264293819137 170425996347293 257404837723318 262202390628140